__turbopack_context__.v({
  "active": "SecondaryMenuNewLp-module-scss-module__SMsryq__active",
  "container": "SecondaryMenuNewLp-module-scss-module__SMsryq__container",
  "list_item": "SecondaryMenuNewLp-module-scss-module__SMsryq__list_item",
  "list_wrapper": "SecondaryMenuNewLp-module-scss-module__SMsryq__list_wrapper",
  "root": "SecondaryMenuNewLp-module-scss-module__SMsryq__root",
});
